import { memo } from 'react';
import { Collapse, Stack } from '@chakra-ui/react';

import TooltipText from 'shared/TooltipText';

const InputsErrorText = ({ error, hint }) => (
  <Collapse in={error} unmountOnExit>
    <Stack w="full" gap="0" pos="absolute" bottom="-1px">
      <Stack w="full" maxH={{ laptop: '24px', mobile: '18px' }} pos="absolute" top="0" left="0">
        <TooltipText
          isFullWidth
          title={hint}
          titleProps={{
            pl: { mobile: '20px', tablet: '24px' },
            color: error && '#C63720',
            fontWeight: '400',
            fontSize: '12px',
            lineHeight: '140%',
            letterSpacing: '0',
            transition: 'all .2s',
            transform: error ? 'translateX(0px)' : 'translateX(10px)',
            noOfLines: 1,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            opacity: error ? 1 : 0,
            zIndex: '0',
          }}
          tooltipProps={{
            hasArrow: false,
            placement: 'bottom',
            modifiers: [{ name: 'offset', options: { offset: [0, -16] } }],
          }}
        />
      </Stack>
    </Stack>
  </Collapse>
);

export default memo(InputsErrorText);
